import { useEffect, useRef } from "react";
import { FieldErrors } from "react-hook-form";

/**
 * Custom hook that automatically scrolls to the top of the page
 * when validation fails after a form submission.
 * Does not trigger when fixing fields.
 */
export const useScrollToError = (errors: FieldErrors, submitCount: number) => {
  const prevSubmitCount = useRef(0);

  useEffect(() => {
    // Only scroll when submitCount increases (new submit) AND there are errors
    if (
      submitCount > prevSubmitCount.current &&
      Object.keys(errors).length > 0
    ) {
      // Small delay to ensure error banner is rendered
      const timeoutId = setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);

      prevSubmitCount.current = submitCount;
      return () => clearTimeout(timeoutId);
    }
    prevSubmitCount.current = submitCount;
  }, [submitCount, errors]);
};
